module.exports = __webpack_public_path__ + "img/logo.43be0aab.png";